import React from 'react';
import { Grid, Typography } from '@mui/material';
import Image from 'next/legacy/image';
import { ImgUrl } from '@/config';
import { ICommunityPlaceDetails } from '@/interfaces/community/verify-place';

interface FromWithServiceProps {
    dataSet: ICommunityPlaceDetails;
}

export default function FromWithService({ dataSet }: FromWithServiceProps) {

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
                <Image
                    src={`${ImgUrl.imgLogoPlace}${dataSet.logoImage}`}
                    alt={dataSet.slug}
                    width={150}
                    height={150}
                    layout="responsive"
                    priority
                    className="author-img rounded-circle"
                    style={{
                        borderRadius:"50%"
                    }}
                />
            </Grid>
            <Grid item xs={9}>
                <Typography variant="body2" className="text-left py-2">
                    {dataSet.placeAddress}
                </Typography>
                <Typography variant="h4" component="div" className="text-left py-2"
                    sx={{
                        fontFamily: "NotoSans-SemiBold, NotoSansThai-SemiBold !important",
}}
                >
                    {dataSet.placeName}
                </Typography>
            </Grid>
        </Grid>
    );
}
